module.exports = __webpack_public_path__ + "img/operacion.5694504d.jpg";